import { View, Text, StyleSheet } from '@react-pdf/renderer'
import React from 'react'

const styles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 40,
    right: 40,
    borderTopWidth: 2,
    borderTopColor: '#00BFD4',
    paddingTop: 6,
    textAlign: 'center',
    fontSize: 9,
  },
  footerTextBold: {
    fontWeight: 'bold',
    marginBottom: 2,
  },
  footerText: {
    fontSize: 9,
  }
})

const FooterOfPDF = () => {
  return (
    <View style={styles.footer} >
      <Text style={styles.footerTextBold}>DUSTRE COMÉRCIO E FABRICAÇÃO DE LIGAS ESPECIAIS LTDA.</Text>
      <Text style={styles.footerText}>Av. Dr. Mauro Lindemberg Monteiro, 1.259 | Jardim Santa Fé | 06278-010 | Osasco - SP | Brasil</Text>
    </View>
  )
}

export default FooterOfPDF